import s from './MessagesSeparator.module.css'

type Props = {
  text: string
}

export const MessagesSeparator = ({ text }: Props) => {
  return <div className={s.container}>{text}</div>
}
